import * as React from 'react'
import { IRiderObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import WalletTransactionHistoryItem from './WalletTransactionHistoryListItem'
import classNames from 'classnames'

interface IWalletTransactionHistoryListProps {
  rider: IRiderObject
  timeFormat: string
}

class WalletTransactionHistoryList extends React.Component<IWalletTransactionHistoryListProps, any> {
  constructor(props: any) {
    super(props)
  }

  public render() {
    const { rider } = this.props

    return (
      <div
        className={classNames('wallet-transaction-list-table', {
          'min-w99 border-light-grey4':
            rider && rider.walletTransactionHistory && rider.walletTransactionHistory.length === 0
        })}
      >
        {rider && rider.walletTransactionHistory && rider.walletTransactionHistory.length > 0 && (
          <>
            <div className='flex'>
              <div className='col-2'>
                <span className='h5 font-grey2'>{UIMessages.common.date}</span>
              </div>
              <div className='col-4'>
                <span className='h5 font-grey2'>{UIMessages.common.transactionId}</span>
              </div>
              <div className='col-1'>
                <span className='h5 font-grey2'>{UIMessages.common.tripId}</span>
              </div>
              <div className='col-1'>
                <span className='h5 font-grey2'>{UIMessages.common.type}</span>
              </div>
              <div className='col-2'>
                <span className='h5 font-grey2'>{UIMessages.common.paymentMethod}</span>
              </div>
              <div className='col-1-5'>
                <span className='h5 font-grey2'>{UIMessages.common.amount}</span>
              </div>
              <div className='col-1-5'>
                <span className='h5 font-grey2'>{UIMessages.common.balance}</span>
              </div>
              <div className='col-3'>
                <span className='h5 font-grey2'>{UIMessages.common.transactionMessage}</span>
              </div>
              <div className='col-2'>
                <span className='h5 font-grey2'>{UIMessages.common.transactionInitiator}</span>
              </div>
            </div>
            <div className='bt-light-grey4'>&nbsp;</div>
          </>
        )}
        {rider &&
          rider.walletTransactionHistory &&
          Object.keys(rider.walletTransactionHistory).map((item, i) => (
            <WalletTransactionHistoryItem
              key={`tmli-${i}`}
              transaction={rider.walletTransactionHistory[item]}
              timeFormat={this.props.timeFormat}
            />
          ))}
        {rider && rider.walletTransactionHistory && rider.walletTransactionHistory.length === 0 && (
          <div className='p3 m3 flex items-center justify-center h5 font-grey2'>
            No Existing Wallet Transaction History
          </div>
        )}
      </div>
    )
  }
}

export default WalletTransactionHistoryList



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/wallet/WalletTransactionHistoryList.tsx